import { mountLegalPage } from './mount-legal';

mountLegalPage('privacy');
